<template>
  <q-page class="bg-indigo-6">
    <div class="q-px-md absolute-center full-width">
      <q-icon
        name="lock"
        color="amber-6"
        class="text-center full-width q-mb-sm"
        style="font-size: 30vw;"
      />
      <div class="text-h5 pc-bold text-white text-center q-mb-lg">
        PassCrate
      </div>
      <q-input
        label="Email"
        type="email"
        standout="bg-white text-indigo-6"
        class="q-mb-md"
        rounded
        dark
        v-model="loginData.email"
      />
      <q-input
        label="Password"
        type="password"
        standout="bg-white text-indigo-6"
        class="q-mb-md"
        rounded
        dark
        v-model="loginData.password"
      />
      <q-btn
        no-caps
        rounded
        color="amber-6"
        text-color="white"
        push
        class="full-width q-py-sm pc-font pc-bold q-mb-md"
        @click="login()"
        :disable="loadingStatus"
      >
        <template v-if="!loadingStatus">
          <q-icon name="login" class="on-left" />Login
        </template>
        <q-spinner-dots color="white" size="1em" v-else />
      </q-btn>
      <div class="row q-mb-xl">
        <router-link to="/register" style="text-decoration: none;">
          <div class="text-subtitle2 text-indigo-2 pc-bold">
            Create account
          </div>
        </router-link>
        <q-space />
        <router-link to="/about" style="text-decoration: none;">
          <div class="text-subtitle2 text-indigo-2 pc-bold">
            About
          </div>
        </router-link>
      </div>
      <div class="row q-mt-xl">
        <q-space />
        <router-link to="/password-reset" style="text-decoration: none;">
          <div class="text-subtitle2 text-indigo-2 pc-bold">
            Forgot password?
          </div>
        </router-link>
        <q-space />
      </div>
    </div>
  </q-page>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      loginData: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    ...mapActions("authStore", ["loginUser"]),

    login() {
      if (!this.loginData.email || !this.loginData.password) {
        this.$q.notify({
          message: "Please insert email and password",
          color: "red-6",
          icon: "error",
          badgeColor: "amber-6",
          progress: true,
          classes: "pc-font pc-semibold higher-toast",
          timeout: 2000,
        });
      } else this.loginUser(this.loginData);
    },
  },
  computed: {
    ...mapState("authStore", ["loadingStatus"]),
  },
};
</script>
